import React from 'react'
import { Box, Modal } from '@mui/material'
import CheckIcon from '@mui/icons-material/Check'

const ModelContainerStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  color: 'white',
}

type Props = {
  open: boolean
  handleClose: () => void
  handleOk: () => void
  handleNo: () => void
}

const MobileFormConfirmationModal: React.FC<Props> = ({
  open,
  handleClose,
  handleOk,
  handleNo,
}) => {
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            ...ModelContainerStyle,
            width: { xs: 'calc(100% - 24px)', sm: '90%', md: 510 },
            maxWidth: 510,
            textAlign: 'center',
          }}
          className="bg-grad before:rounded-[40px] bg-[#2B24600D] padding-none overflow-hidden"
        >
          <div className="px-5 py-6 md:px-[80px] md:py-[52px] rounded-[40px] backdrop-blur-xl">
            <div className="popup_content_wrapper">
              <div className="bg-[#FB5012] p-3 rounded-full mt-2 mb-4 w-[60px] h-[60px]">
                <CheckIcon sx={{ fontSize: '35px' }} />
              </div>
              <h2 className="text-xl md:text-2xl font-semibold mb-4">
                Are You Sure You <br /> Want to Mark It Closed ?
              </h2>
              <p className="mb-4">
                Please confirm if you want to proceed with closing the request.
              </p>
            </div>
            <div className="mt-4 flex items-center justify-center gap-4">
              <button
                className="border-2 border-[#FB5012] text-[#FB5012] px-6 py-2 rounded-[40px]"
                onClick={() => {
                  handleOk()
                }}
              >
                Yes
              </button>
              <button
                className="px-6 py-2 rounded-[40px] bg-[#FB5012]"
                onClick={() => {
                  handleNo()
                }}
              >
                No
              </button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  )
}
export default MobileFormConfirmationModal
